// extracted by mini-css-extract-plugin
module.exports = {"Letter":"Letter_Letter__EWj6L"};